import ScrollBooster from 'scrollbooster';

export default function () {

  document.addEventListener('DOMContentLoaded', function(){
    // タブにクリックイベントを付与
    const tabs = document.getElementsByClassName('tab');
    for(let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', tabSwitch, false);
    }

    // 1番目のパネルだけ可視化
    const panels = document.getElementsByClassName('panel');
    for(let i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-show');
    }
    panels[0].classList.add('is-show');

    // タブの切り替え
    function tabSwitch(){
      document.getElementsByClassName('is-active')[0].classList.remove('is-active');
      this.classList.add('is-active');
      document.getElementsByClassName('is-show')[0].classList.remove('is-show');
      const arrayTabs = Array.prototype.slice.call(tabs);
      const index = arrayTabs.indexOf(this);
      document.getElementsByClassName('panel')[index].classList.add('is-show');
    }

    // URL でタブやセクションの指定があればそこにジャンプする
    const urlParams = new URLSearchParams(window.location.search);
    const tabType = urlParams.get("tab");
    const contentId = urlParams.get("content_id");
    const $contentElement = document.querySelector(`#${contentId}`);
    const $tabElement = document.querySelector(`.js-${tabType}`);

    if ($tabElement) {
      const $panelElement = document.querySelector(`.panel.js-${tabType}-info`);
      document.getElementsByClassName("is-active")[0].classList.remove("is-active");
      document.getElementsByClassName("is-show")[0].classList.remove("is-show");
      $tabElement.classList.add("is-active");
      $panelElement.classList.add("is-show");
    }

    if ($contentElement) {
      window.scroll({ top: $contentElement.offsetTop - 60, behavior: "smooth" });
    }

    // バックエンドから渡されてきたNFT発行手数料の情報を、所定の位置に埋め込む
    const mainElement = document.getElementById('static-main');
    const attributes = ['ethereumMintFee', 'polygonMintFee', 'nftMintFeesStartDate'];

    attributes.forEach(attr => {
      document.querySelectorAll(`.js-${attr}`).forEach(element => {
        let value = mainElement.getAttribute(`data-${attr}`);
        if (attr === "nftMintFeesStartDate") {
          value = value.replace(/-/g, "/");
        }
        element.textContent = value;
      });
    });
  }, false);

}
